import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileExport from "../../../Assets/Images/CommanImages/fileexport.png";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Warning.png";
import FlagIcon from "./../../../Assets/Images/CommanImages/flag_icon.png";
import FlagIconEmpty from "./../../../Assets/Images/CommanImages/tabler_flag-empty.png";
import EyeLockIcon from "./../../../Assets/Images/CommanImages/eye-lock-icon.png";
import SuccessIcon from "./../../../Assets/Images/CommanImages/Informative.png";
import SelectedValuesDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import he from "he";
import "./tab.css";

const TableComponent = ({
  headers,
  data,
  searchPlaceholder,
  // setPagePath,
  renderQuestionText,
  selectedRows,
  setSelectedRows,
  setMessageBox,
  // messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  // setNoTimeSet,
  // setSelectedQuestions,
  setDifficultyCount,
  showFlagModal,
  setShowFlagModal,
  isReadOnly,
  setFlaggedQuestions,
  // flaggedQuestions,
  activeSubjectId,
  setVersion,
  setReportDashboardData,
}) => {
  const navigate = useNavigate();
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [averageRunTime, setAverageRunTime] = useState("");
  const isAllSelected = selectedRows.length === data.length;
  const columnDropdownRef = useRef(null);
  const [filters, setFilters] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [isFilterDropdownSelected, setIsFilterDropdownSelected] =
    useState(false);
  // const [showFlagModal, setShowFlagModal] = useState(false);
  const [flagCommentQuesId, setFlagCommentQuesId] = useState(null);
  const [flagComment, setFlagComment] = useState("");
  const [flagCommentError, setFlagCommentError] = useState(false);
  // const [flaggedQuestions, setFlaggedQuestions] = useState([]);
  const [flagPopupError, setFlagPopupError] = useState("");
  //  const [selectedQuestionData, setSelectedQuestionData] = useState(null);
  // const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
  const [selectedQuestionData, setSelectedQuestionData] = useState(null);
  const [isQuesModalVisible, setIsQuesModalVisible] = useState(false);
  const [questionOptions, setQuestionOptions] = useState([]);

  const fetchQuestionOptions = async (questionId) => {
    try {
      const accessToken = localStorage.getItem("other");
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-ques-options-by-ques-id-list`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ques_id_list: [questionId],
          }),
        }
      );

      const result = await response.json();
      if (result.status === 200) {
        const options = result.data.questions?.[0]?.ques_options || [];
        setQuestionOptions(options);
      } else {
        setQuestionOptions([]);
      }
    } catch (err) {
      console.error("Failed to fetch options:", err);
      setQuestionOptions([]);
    }
  };

  // useEffect(() => {
  //   if (headers.length > 0 && visibleColumns.length === 0) {
  //     const initialVisible = headers
  //       .slice(0, 6)
  //       .filter((_, index) => index !== 3 && index !== 5);
  //     setVisibleColumns(initialVisible);
  //   }
  // }, [headers, visibleColumns]);

  useEffect(() => {
    if (headers.length > 0 && visibleColumns.length === 0) {
      // "Question ID" must always be included
      const mustHave = ["Question ID"];

      // Get first 6 other columns (excluding Question ID)
      const initial = headers
        .filter((header) => !mustHave.includes(header))
        .slice(0, 6);

      // Combine with Question ID in natural order
      const initialWithMustHave = headers.filter(
        (h) => mustHave.includes(h) || initial.includes(h)
      );

      setVisibleColumns(initialWithMustHave);
    }
  }, [headers]);

  const handleFlagClick = (questionId) => {
    setFlagCommentQuesId(questionId);
    setShowFlagModal(true);
  };

  const handleSubmitFlag = async () => {
    if (!flagComment.trim()) {
      setFlagCommentError(true);
      return;
    }

    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/post-parse-ques-review-request?parse_ques_set_question_id=${flagCommentQuesId}&comments=${encodeURIComponent(
          flagComment
        )}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      if (result?.success === "Request created successfully") {
        setFlaggedQuestions((prev) => [...prev, flagCommentQuesId]);
        //  setFlaggedQuestions((prev) => [...prev, flagCommentQuesId]);

        // ✅ PATCH REPORT DATA TO SHOW RED FLAG WITHOUT REFRESH
        setReportDashboardData((prevData) =>
          prevData.map((row) =>
            row[0] === flagCommentQuesId
              ? row.map((cell, i) =>
                  headers[i] === "Review Status" ? 1 : cell
                )
              : row
          )
        );

        // ✅ Show success message
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Question flagged successfully.</span>
            </div>
          </div>
        );
        setActiveImg(SuccessIcon);
        setShowFlagModal(false);
        setFlagComment("");
        setFlagCommentError(false);
        setFlagPopupError("");
      } else {
        setFlagPopupError(result?.message || "Flagging failed.");
      }
    } catch (error) {
      console.error("Error flagging question:", error);
      setFlagPopupError("Something went wrong while flagging.");
    }
  };

  // const handleColumnSelection = (column) => {
  //   if (visibleColumns.includes(column)) {
  //     setVisibleColumns(visibleColumns.filter((col) => col !== column));
  //   } else {
  //     setVisibleColumns([...visibleColumns, column]);
  //   }
  // };

  const handleColumnSelection = (column) => {
    // Prevent toggling "Question ID"
    if (column === "Question ID") {
      return;
    }

    // Toggle all other columns normally
    if (visibleColumns.includes(column)) {
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleApplyFilter = () => {
    if (Object.keys(filters).length > 0) {
      setAppliedFilters({ ...filters }); // Persist selected filters
      setCurrentPage(1); // Reset to the first page
      setIsFiltersApplied(true); // Show Reset button
      setIsFilterVisible(false); // Hide the filter sidebar
    }
  };

  const handleResetFilter = () => {
    setFilters({}); // Clear current filter selections
    setAppliedFilters({}); // Clear applied filters
    setAverageRunTime(""); // Reset any other state if required
    setIsFiltersApplied(false); // Deactivate the Reset button
  };

  const handleFilterSelection = (selectedOption, header) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [header]: selectedOption,
    }));

    setIsFilterDropdownSelected(true); // Mark dropdown as interacted
  };

  const filteredData = data.filter((row) => {
    const matchesSearchQuery = row.some(
      (cell) =>
        cell && String(cell).toLowerCase().includes(searchQuery.toLowerCase())
    );
    const matchesAverageRunTime =
      averageRunTime === "" || row[2] === averageRunTime;

    // Apply appliedFilters
    const matchesFilters = Object.entries(appliedFilters).every(
      ([key, value]) => {
        const colIndex = headers.indexOf(key);
        return value ? row[colIndex] === value : true;
      }
    );

    return matchesSearchQuery && matchesAverageRunTime && matchesFilters;
  });

  const handleSort = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        columnDropdownRef.current &&
        !columnDropdownRef.current.contains(event.target)
      ) {
        setIsColumnDivVisible(false); // Close the dropdown if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sortedData = React.useMemo(() => {
    let sortableData = [...filteredData];
    if (sortConfig.key !== null) {
      const colIndex = headers.indexOf(sortConfig.key);
      sortableData.sort((a, b) => {
        if (a[colIndex] < b[colIndex]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[colIndex] > b[colIndex]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [filteredData, sortConfig, headers]);

  const handleExport = (type) => {
    const exportData = sortedData.map((row) =>
      visibleColumns.map((column) => row[headers.indexOf(column)])
    );

    const fileName = prompt("Enter the file name:");

    if (!fileName) {
      return;
    }

    if (type === "excel" || type === "csv") {
      const worksheet = XLSX.utils.aoa_to_sheet([
        visibleColumns,
        ...exportData,
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileExtension = type === "csv" ? "csv" : "xlsx";
      const mimeType =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const file = XLSX.write(workbook, {
        bookType: fileExtension,
        type: "array",
      });
      const blob = new Blob([file], { type: mimeType });
      FileSaver.saveAs(blob, `${fileName}.${fileExtension}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({
        head: [visibleColumns],
        body: exportData,
      });

      doc.save(`${fileName}.pdf`);
    }
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(sortedData.length / pageSize);
  const paginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return sortedData.slice(startIndex, startIndex + pageSize);
  }, [sortedData, currentPage, pageSize]);

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageChange(i)}
            style={{ borderRadius: "5px" }}
            className={i === currentPage ? "active" : ""}
          >
            {i}
          </button>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pages.push(
            <button
              key={i}
              style={{ borderRadius: "5px" }}
              onClick={() => handlePageChange(i)}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots2">
            ...
          </span>
        );
        pages.push(
          <button
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
            style={{ borderRadius: "5px" }}
          >
            {totalPages}
          </button>
        );
      } else {
        pages.push(
          <button
            key={1}
            onClick={() => handlePageChange(1)}
            style={{ borderRadius: "5px" }}
          >
            1
          </button>
        );
        pages.push(
          <span style={{ borderRadius: "5px" }} key="dots1">
            ...
          </span>
        );
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pages.push(
            <button
              key={i}
              onClick={() => handlePageChange(i)}
              style={{ borderRadius: "5px" }}
              className={i === currentPage ? "active" : ""}
            >
              {i}
            </button>
          );
        }
      }
    }
    return pages;
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(data.map((row) => row[0])); // Assuming the first column contains the question ID
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelect = (questionId) => {
    const selectedRow = data.find((row) => row[0] === questionId);
    const difficultyLevelIndex = headers.findIndex((header) =>
      header.toLowerCase().includes("difficulty level")
    );
    const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

    const existingMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const currentSubjectId = String(activeSubjectId);
    const existingIds = existingMap[currentSubjectId] || [];

    const isAlreadySelected = existingIds.includes(questionId);
    const updatedIds = isAlreadySelected
      ? existingIds.filter((id) => id !== questionId)
      : [...new Set([...existingIds, questionId])];

    const updatedMap = {
      ...existingMap,
      [currentSubjectId]: updatedIds,
    };

    localStorage.setItem(
      "subjectWiseSelectedRowIds",
      JSON.stringify(updatedMap)
    );
    setVersion((prev) => prev + 1);

    // ✅ Remove from subjectWiseDeletedRowIds if being re-selected
    if (!isAlreadySelected) {
      const deletedMap = JSON.parse(
        localStorage.getItem("subjectWiseDeletedRowIds") || "{}"
      );
      const updatedDeleted = (deletedMap[currentSubjectId] || []).filter(
        (id) => id !== questionId
      );
      localStorage.setItem(
        "subjectWiseDeletedRowIds",
        JSON.stringify({
          ...deletedMap,
          [currentSubjectId]: updatedDeleted,
        })
      );
    }

    // ✅ Difficulty count still needs to be updated in memory (UI live update)
    if (["easy", "medium", "tough"].includes(difficulty)) {
      setDifficultyCount((prev) => {
        const updated = { ...prev };
        if (isAlreadySelected) {
          updated[difficulty] = Math.max(0, updated[difficulty] - 1);
        } else {
          updated[difficulty] += 1;
        }
        return updated;
      });
    }
  };

  const [columnWidth, setColumnWidth] = useState(400);
  const columnRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = (event) => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (event) => {
    if (isResizing.current) {
      const newWidth = Math.max(
        100,
        event.clientX - columnRef.current.offsetLeft
      ); // Min width: 100px
      setColumnWidth(newWidth);
    }
  };

  const handleMouseUp = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  // Ensure the KaTeX MathML elements do not cause unwanted scrollbars
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .katex .katex-mathml {
        position: static !important;
        width: auto !important;
        height: auto !important;
        clip: auto !important;
        overflow: hidden !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // place near other memos/states
  const questionIdCol = 0; // first column is id
  const questionTextCol =
    headers.indexOf("Question Text") >= 0
      ? headers.indexOf("Question Text")
      : 1;

  // Build a flat list of {id, text} in the same order as the table shows
  const modalList = React.useMemo(() => {
    return sortedData.map((row) => ({
      id: row[questionIdCol],
      text: row[questionTextCol],
    }));
  }, [sortedData, questionIdCol, questionTextCol]);

  // Current index in that list
  const currentModalIndex = React.useMemo(() => {
    if (!selectedQuestionData) return -1;
    return modalList.findIndex((q) => q.id === selectedQuestionData.id);
  }, [modalList, selectedQuestionData]);

  const loadQuestionAtIndex = (idx) => {
    if (idx < 0 || idx >= modalList.length) return;
    const q = modalList[idx];
    setSelectedQuestionData({ id: q.id, text: q.text });
    fetchQuestionOptions(q.id);
  };
  const handleNextQuestion = () => loadQuestionAtIndex(currentModalIndex + 1);
  const handlePrevQuestion = () => loadQuestionAtIndex(currentModalIndex - 1);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            ></div>
            <img
              src={searchicon}
              alt="search"
              className="search-icon-ques-dash"
            />
          </div>
          <div
            style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}
          >
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedData.length)} -{" "}
            {Math.min(currentPage * pageSize, sortedData.length)} of{" "}
            {sortedData.length} records |
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration:
                    size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        <div
          style={{
            backgroundColor: "#FFBD20",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
          }}
          onClick={() => setIsFilterVisible(!isFilterVisible)}
        >
          <img
            src={Filter}
            style={{ height: "24px", width: "24px" }}
            alt="filter"
          />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Filter</span>
        </div>
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={() => setIsColumnDivVisible(!isColumnDivVisible)}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <div ref={columnDropdownRef}>
              <div className="arrow-up-tc"></div>
              <div className="popupColumn-tc-ques-list">
                {/* {headers
                  .filter((_, index) => index !== 3 && index !== 5) // Skip index 4 and 5
                  .map((column, index) => (
                    <div
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent closing of the columnDiv
                        handleColumnSelection(column);
                      }}
                    >
                      <input
                        type="checkbox"
                        id={`column-${index}`}
                        name="columnSelection"
                        value={column}
                        className="square-checkbox-tc"
                        checked={visibleColumns.includes(column)}
                        readOnly
                      />
                      <label htmlFor={`column-${index}`}>{column}</label>
                    </div>
                  ))} */}
                {headers.map((column, index) => (
                  <div
                    key={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleColumnSelection(column);
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`column-${index}`}
                      value={column}
                      className="square-checkbox-tc"
                      checked={visibleColumns.includes(column)}
                      disabled={column === "Question ID"}
                      readOnly
                    />
                    <label htmlFor={`column-${index}`}>{column}</label>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {data.length > 0 ? (
        <>
          <div className="table-wrapper-cols-selections-ques-list">
            <table className="table-tc" style={{ width: "100%" }}>
              <thead>
                <tr>
                  {visibleColumns.map((heading, index) => (
                    <td
                      key={index}
                      ref={index === 1 ? columnRef : null}
                      className={`Heading-tc resizable-header ${
                        index === 1 ? "resizable-header" : ""
                      }`}
                      style={{
                        textAlign: "right",
                        cursor: "pointer",
                        width: index === 1 ? `${columnWidth}px` : "auto",
                        position: "relative", // Ensure position for pseudo-element
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "left",
                          justifyContent: "left",
                          marginLeft: index === 0 ? "112px" : "",
                        }}
                      >
                        {/* {index === 0 && (
                          <input
                            type="checkbox"
                            className="delete-question-checkbox-dqc"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                          />
                        )} */}
                        {heading}
                        {index === 1 && (
                          <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                          ></div>
                        )}
                        <img
                          onClick={() => handleSort(heading)}
                          src={updown}
                          style={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "5px",
                          }}
                          alt="sort"
                        />
                      </span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((row, rowIndex) => (
                  <tr
                    key={rowIndex}
                    className={rowIndex % 2 === 1 ? "even-row-tc" : ""}
                  >
                    {visibleColumns.map((column, cellIndex) => (
                      <td
                        key={cellIndex}
                        style={{
                          width: cellIndex === 1 ? `${columnWidth}px` : "100px",
                          textAlign: "left",
                          color: "#6A6A6A",
                          verticalAlign: "middle",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: `${columnWidth}px`,
                        }}
                      >
                        {cellIndex === 0 ? ( // Ensure link only appears once
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              className="flag-container-ques-bank-dash"
                              style={{ width: "90px" }}
                            >
                              {/* {flaggedQuestions.includes(row[0]) ? (
                                <img src={FlagIcon} alt="flagged" style={{ width: "24px" }} />
                              ) : (
                                <img src={FlagIconEmpty} alt="flag" style={{ width: "24px", cursor: "pointer" }} onClick={() => handleFlagClick(row[0])} />
                              )} */}
                              {row[headers.indexOf("Review Status")] === 1 ? (
                                <img
                                  src={FlagIcon}
                                  alt="flagged"
                                  style={{ width: "24px" }}
                                />
                              ) : (
                                <img
                                  src={FlagIconEmpty}
                                  alt="flag"
                                  style={{ width: "24px", cursor: "pointer" }}
                                  onClick={() => handleFlagClick(row[0])}
                                />
                              )}
                              {row[3] === 13 && (
                                <img
                                  src={EyeLockIcon}
                                  alt="flag count"
                                  style={{ width: "24px" }}
                                />
                              )}
                            </div>
                            {/* <input
                              type="checkbox"
                              className="delete-question-checkbox-dqc"
                              checked={selectedRows.includes(row[0])}
                              onChange={() => handleRowSelect(row[0])}
                              disabled={isReadOnly}
                              style={{opacity: isReadOnly ? 0.6 : 1}}
                            /> */}
                            <input
                              type="checkbox"
                              className="delete-question-checkbox-dqc"
                              checked={(
                                JSON.parse(
                                  localStorage.getItem(
                                    "subjectWiseSelectedRowIds"
                                  ) || "{}"
                                )[activeSubjectId] || []
                              ).includes(row[0])}
                              onChange={() => handleRowSelect(row[0])}
                              disabled={isReadOnly}
                              style={{ opacity: isReadOnly ? 0.6 : 1 }}
                            />
                            <Link
                              style={{ color: "#337ab7" }}
                              onClick={() => {
                                const questionId = row[0];
                                setSelectedQuestionData({
                                  id: questionId,
                                  text: row[
                                    headers.indexOf("Question Text") || 1
                                  ],
                                });
                                fetchQuestionOptions(questionId);
                                setIsQuesModalVisible(true);
                              }}
                            >
                              <span
                                className="truncated-text"
                                title={row[headers.indexOf(column)]}
                              >
                                {headers.indexOf(column) === 1
                                  ? renderQuestionText(
                                      row[headers.indexOf(column)]
                                    )
                                  : row[headers.indexOf(column)]}
                              </span>
                            </Link>
                          </div>
                        ) : (
                          <span className="truncated-text-2">
                            {headers.indexOf(column) === 1
                              ? renderQuestionText(row[headers.indexOf(column)])
                              : row[headers.indexOf(column)]}
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination-tc" style={{ marginBottom: "10px" }}>
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
              className="extreme-left-tc-pagination"
            >
              {" "}
              <img src={leftArrow} alt="" />{" "}
            </button>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="lefttc-pagination"
            >
              {" "}
              {"<"}{" "}
            </button>
            {renderPagination()}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="righttc-pagination"
            >
              {" "}
              {">"}{" "}
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
              className="extreme-right-tc-pagination"
            >
              {" "}
              <img src={rightArrow} alt="" />{" "}
            </button>
          </div>
        </>
      ) : (
        "No data available"
      )}
      {isFilterVisible && (
        <div className="filter-sidebar-tc">
          <div className="filter-content-tc" style={{ position: "relative" }}>
            <button
              className="repman-cross-btn"
              onClick={() => {
                setIsFilterVisible(false);
              }}
            >
              {" "}
              <p>X</p>{" "}
            </button>
            <h3 className="AdvanceF-heading-tc"> Filter</h3>
            <div className="filter-apply-reset-ques-rev-dash">
              {isFiltersApplied && (
                <button
                  className="reset-btn-question-review-dash"
                  onClick={handleResetFilter}
                >
                  {" "}
                  RESET{" "}
                </button>
              )}
              <button
                className="apply-btn-question-review-dash"
                onClick={handleApplyFilter}
              >
                {" "}
                APPLY{" "}
              </button>
            </div>
            <div className="filter-options-container">
              {headers
                .filter((_, index) => index !== 1 && index !== 3 && index !== 4) // Skip index 1, 3, 4
                .map((header, filteredIndex) => {
                  // Map filtered index back to original index
                  const skippedIndexes = [1, 3, 4];
                  let count = -1;
                  const originalIndex = headers.findIndex((_, i) => {
                    if (!skippedIndexes.includes(i)) {
                      count++;
                      return count === filteredIndex;
                    }
                    return false;
                  });

                  const uniqueOptions = [
                    ...new Set(
                      data
                        .map((row) => row[originalIndex])
                        .filter((option) => option)
                    ),
                  ];
                  if (originalIndex === 0 || originalIndex === 6) {
                    uniqueOptions.sort((a, b) => (a > b ? 1 : -1));
                  }

                  return (
                    <SelectedValuesDropdown
                      key={originalIndex}
                      label={header}
                      width="300px"
                      marginLeft="15px"
                      marginTop="18px"
                      setSelected={(selectedOption) => {
                        setFilters((prevFilters) => ({
                          ...prevFilters,
                          [header]: selectedOption,
                        }));
                      }}
                      options={uniqueOptions.map((value) => ({
                        label: value,
                        id: value,
                      }))}
                      selected={filters[header] || ""}
                      Height="auto"
                      OverFlow="auto"
                      minheight="200px"
                    />
                  );
                })}
            </div>
          </div>
        </div>
      )}
      {showFlagModal && (
        <div className="flag-modal-overlay-qus-list">
          <div className="flag-modal-box-qus-list">
            <h3 className="flag-modal-title-qus-list">REVIEW REQUEST</h3>

            <div className="flag-modal-input-group-qus-list">
              <label className="flag-modal-label-qus-list">Comments</label>
              <textarea
                value={flagComment}
                onChange={(e) => {
                  const value = e.target.value;
                  setFlagComment(value);
                  if (flagCommentError && value.trim()) {
                    setFlagCommentError(false);
                  }
                }}
                className={
                  flagCommentError
                    ? "flag-modal-textarea-qus-list error-border-qus-list"
                    : "flag-modal-textarea-qus-list"
                }
                placeholder="Enter comment to flag this question"
              />
              {flagCommentError && (
                <span className="flag-modal-error-qus-list">
                  {" "}
                  Flag comment is required.{" "}
                </span>
              )}
            </div>
            {flagPopupError && (
              <div
                className="flag-modal-error-qus-list"
                style={{ marginBottom: "20px" }}
              >
                {" "}
                {flagPopupError}{" "}
              </div>
            )}
            <div className="flag-modal-actions-qus-list">
              <button
                className="flag-modal-button-qus-list cancel-qus-list"
                onClick={() => {
                  setShowFlagModal(false);
                  setFlagComment("");
                  setFlagCommentError(false);
                  setFlagPopupError("");
                }}
              >
                CANCEL
              </button>
              <button
                className="flag-modal-button-qus-list submit-qus-list"
                onClick={handleSubmitFlag}
              >
                {" "}
                SAVE{" "}
              </button>
            </div>
          </div>
        </div>
      )}
      {isQuesModalVisible && selectedQuestionData && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
        >
          <button
            className="modal-close-outside"
            aria-label="Close"
            onClick={(e) => {
              e.stopPropagation();
              setIsQuesModalVisible(false);
            }}
          >
            ×
          </button>
          {/* <div 
              className="modal-content-all-question" 
              onClick={(e) => e.stopPropagation()}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                  e.preventDefault();
                  if (currentModalIndex >= 0 && currentModalIndex < modalList.length - 1) {
                    handleNextQuestion();
                  }
                } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                  e.preventDefault();
                  if (currentModalIndex > 0) {
                    handlePrevQuestion();
                  }
                } else if (e.key === 'Escape') {
                  setIsQuesModalVisible(false);
                }
              }}
              style={{ outline: 'none' }}
            >
              <div className="modal-header-del">
                <p 
                style={{
                    fontSize: "18px",
                    color: "#424342",
                    margin: 0,
                    padding: "10px 14px",
                    backgroundColor: "transparent",
                    borderBottom: "1px solid #d6d6d6",
                    userSelect: "none"
                  }}>
                  QUESTION ID - {selectedQuestionData.id}
                </p>
              </div>

              <div className="modal-question-options">
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                  <span style={{ fontSize: "18px",  color: "#424342" }}>Question:</span>
                </div>

                <div className="question-body-plain" style={{ fontSize: "22px"}}>
                  {renderQuestionText(selectedQuestionData.text)}
                </div>

                {questionOptions.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <span style={{  color: "#424342", fontSize: "18px" }}>Options:</span>
                    <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                      {questionOptions.map((opt, i) => (
                        <li key={i} className="option-list-item">
                          <div className="toggle-radio">
                            <input type="radio" checked={opt.option_correct_flag} readOnly />
                            <div>{renderQuestionText(opt.option_text)}</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="footer-spacer" />
                <div className="modal-actions">
                  <div className="modal-actions-left" />
                  <div className="modal-actions-right">
                    <button type="button" onClick={handlePrevQuestion} disabled={currentModalIndex <= 0} className="btn-secondary action-btn">Previous</button>
                    {(() => {
                      const selectedMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
                      const selectedIds = selectedMap[activeSubjectId] || [];
                      const isSelected = selectedIds.includes(selectedQuestionData.id);
                      return (
                        <button
                          type="button"
                          onClick={() => handleRowSelect(selectedQuestionData.id)}
                          disabled={isReadOnly}
                          className={`btn-primary-soft action-btn ${isSelected ? "is-selected" : ""}`}
                          title={isSelected ? "Unselect this question" : "Select this question"}
                        >
                          {isSelected ? "Remove" : "Add"}
                        </button>
                      );
                    })()}
                    <button type="button" onClick={handleNextQuestion} disabled={currentModalIndex < 0 || currentModalIndex >= modalList.length - 1} className="btn-secondary action-btn">Next</button>
                  </div>
                </div>
              </div>
            </div> */}
          <div
            className="modal-content-all-question"
            onClick={(e) => e.stopPropagation()}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                e.preventDefault();
                if (
                  currentModalIndex >= 0 &&
                  currentModalIndex < modalList.length - 1
                ) {
                  handleNextQuestion();
                }
              } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                e.preventDefault();
                if (currentModalIndex > 0) {
                  handlePrevQuestion();
                }
              } else if (e.key === "Escape") {
                setIsQuesModalVisible(false);
              }
            }}
            style={{ outline: "none" }}
          >
            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  color: "#424342",
                  margin: 0,
                  padding: "10px 14px",
                  backgroundColor: "transparent",
                  userSelect: "none",
                }}
              >
                QUESTION ID - {selectedQuestionData.id}
              </p>
            </div>

            <div className="modal-question-options">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                <span style={{ fontSize: "18px", color: "#424342" }}>
                  Question:
                </span>
              </div>

              <div className="question-body-plain" style={{ fontSize: "22px" }}>
                {renderQuestionText(selectedQuestionData.text)}
              </div>

              {questionOptions.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <span style={{ color: "#424342", fontSize: "18px" }}>
                    Options:
                  </span>
                  <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                    {questionOptions.map((opt, i) => (
                      <li key={i} className="option-list-item">
                        <div className="toggle-radio">
                          <input
                            type="radio"
                            checked={opt.option_correct_flag}
                            readOnly
                          />
                          <div>{renderQuestionText(opt.option_text)}</div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="modal-actions">
              <div className="modal-actions-left" />
              <div className="modal-actions-right">
                <button
                  type="button"
                  onClick={handlePrevQuestion}
                  disabled={currentModalIndex <= 0}
                  className="btn-secondary action-btn"
                >
                  Previous
                </button>
                {(() => {
                  const selectedMap = JSON.parse(
                    localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
                  );
                  const selectedIds = selectedMap[activeSubjectId] || [];
                  const isSelected = selectedIds.includes(
                    selectedQuestionData.id
                  );
                  return (
                    <button
                      type="button"
                      onClick={() => handleRowSelect(selectedQuestionData.id)}
                      disabled={isReadOnly}
                      className={`btn-primary-soft action-btn ${
                        isSelected ? "is-selected" : ""
                      }`}
                      title={
                        isSelected
                          ? "Unselect this question"
                          : "Select this question"
                      }
                    >
                      {isSelected ? "Remove" : "Add"}
                    </button>
                  );
                })()}
                <button
                  type="button"
                  onClick={handleNextQuestion}
                  disabled={
                    currentModalIndex < 0 ||
                    currentModalIndex >= modalList.length - 1
                  }
                  className="btn-secondary action-btn"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const TableDetailsQuesList = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  setPagePath,
  selectedTags,
  filters,
  setSelectedQuestions,
  setSelectedHeaders,
  setDifficultyCount,
  userId,
  showFlagModal,
  setShowFlagModal,
  subjectId,
  courseId,
  scopeRefIds,
  // setAllQuestions,
  setReportDashboardData,
  reportDashboardData,
  isReadOnly,
  selectedRows,
  setSelectedRows,
  activeSubjectId,
  setVersion,
  draftData,
  excludeRepeatCount,
  clientBranchId,
  scopeId,
  setLoadingTab,
  loadingTab,
}) => {
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [flaggedQuestions, setFlaggedQuestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!filters) return;
    fetchDashboardData();
  }, [selectedTags, filters, activeSubjectId, excludeRepeatCount]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            {" "}
            <Latex>{segment}</Latex>{" "}
          </span>
        );
      }
    });
  };

  // Combine those question IDs with localStorage.
  const fetchDashboardData = async () => {
    const accessToken = localStorage.getItem("other");

    // Get localStorage question IDs
    const selectedMap = JSON.parse(
      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
    );
    const selectedIdsFromLocal = selectedMap[activeSubjectId] || [];

    // Get question IDs from draftData with status === 1
    const draftSubject = draftData?.subjects?.find(
      (s) => s.subject_id === activeSubjectId
    );
    const draftSelectedIds =
      draftSubject?.questions
        ?.filter((q) => q.status === 1)
        ?.map((q) => q.parse_ques_set_question_id) || [];

    // Combine both sets of IDs and remove duplicates
    const allSelectedIds = Array.from(
      new Set([...draftSelectedIds, ...selectedIdsFromLocal])
    );

    const promises = [];

    // 1. Get filtered data (if tags/filters are applied)
    // if ((selectedTags && selectedTags.length > 0) || (filters && Object.keys(filters).length > 0)) {
    if (
      (selectedTags && selectedTags.length > 0) ||
      (filters && filters.length > 0)
    ) {
      // promises.push(
      //   fetch(`${FULL_API_BASE_URL}/get-questions-by-tag-filters/?user_id=${userId}&subject_id=${subjectId}&course_id=${courseId}`, {
      //     method: "POST",
      //     headers: {
      //       Authorization: `Bearer ${accessToken}`,
      //       Accept: "application/json",
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({ tags: selectedTags, filters: filters, scope_ref_id: scopeRefIds }),
      //   }).then(res => res.json())
      // );

      const url =
        `${FULL_API_BASE_URL}/get-questions-by-tag-filters/` +
        `?subject_id=${subjectId}` +
        `&course_id=${courseId}` +
        `&scope_id=${scopeId || 0}` +
        `&repeat_n=${excludeRepeatCount || 0}` +
        `&client_branch_id=${clientBranchId}` +
        `&user_id=${userId}`;

      promises.push(
        fetch(url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tags: selectedTags,
            filters: filters,
            scope_ref_id: scopeRefIds,
          }),
        }).then((res) => res.json())
      );
    }

    // 2. Get all selected questions (from draft + localStorage)
    if (allSelectedIds.length > 0) {
      promises.push(
        fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(allSelectedIds),
        }).then((res) => res.json())
      );
    }
    setLoading(true);
    try {
      const results = await Promise.all(promises);
      const allData = [];

      results.forEach((result) => {
        const rawTableData = result?.data?.table_data || [];
        const rawHeaders = rawTableData[0] || [];
        const rawRows = rawTableData.slice(1);
        allData.push(...rawRows);

        if (headers.length === 0 && rawHeaders.length > 0) {
          const cleanedHeaders = rawHeaders.map((h) =>
            h.replace(/^t\*|d\*|n\*/, "")
          );
          setHeaders(cleanedHeaders);
          setSelectedHeaders(cleanedHeaders);
        }
      });

      // Deduplicate by Question ID (index 0)
      const uniqueMap = {};
      allData.forEach((row) => {
        uniqueMap[row[0]] = row;
      });

      const finalRows = Object.values(uniqueMap);
      setReportDashboardData(finalRows);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false); // 🔴 stop loading
    }
  };

  // Add this useEffect at the top level of the component
  useEffect(() => {
    fetchDashboardData();
  }, []); // Dependencies array

  return (
    <div style={{ height: "auto", width: "100%" }}>
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <span>Loading questions...</span>
        </div>
      ) : (
        <div style={{ paddingLeft: "15px" }}>
          <div>
            <TableComponent
              headers={headers}
              data={reportDashboardData}
              searchPlaceholder="Filter Questions..."
              setPagePath={setPagePath}
              renderQuestionText={renderQuestionText}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              setMessageBox={setMessageBox}
              setIsMessageBoxVisible={setIsMessageBoxVisible}
              setActiveImg={setActiveImg}
              setSelectedQuestions={setSelectedQuestions}
              setDifficultyCount={setDifficultyCount}
              showFlagModal={showFlagModal}
              setShowFlagModal={setShowFlagModal}
              isReadOnly={isReadOnly}
              flaggedQuestions={flaggedQuestions}
              setFlaggedQuestions={setFlaggedQuestions}
              activeSubjectId={activeSubjectId}
              setVersion={setVersion}
              setReportDashboardData={setReportDashboardData}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TableDetailsQuesList;

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const currentSubjectId = String(activeSubjectId);
//   const subjectWise = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   const deletedMap = JSON.parse(localStorage.getItem("subjectWiseDeletedRowIds") || "{}");

//   const selectedIds = subjectWise[currentSubjectId] || [];
//   const deletedIds = deletedMap[currentSubjectId] || [];

//   const isAlreadySelected = selectedIds.includes(questionId);
//   const updatedSelected = isAlreadySelected
//     ? selectedIds.filter((id) => id !== questionId)
//     : [...new Set([...selectedIds, questionId])];

//   const updatedDeleted = isAlreadySelected
//     ? deletedIds // Don't touch deleted if you're deselecting
//     : deletedIds.filter((id) => id !== questionId); // ✅ Remove from deleted if re-selecting

//   // 🔁 Save both
//   localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify({
//     ...subjectWise,
//     [currentSubjectId]: updatedSelected
//   }));

//   localStorage.setItem("subjectWiseDeletedRowIds", JSON.stringify({
//     ...deletedMap,
//     [currentSubjectId]: updatedDeleted
//   }));

//   setVersion(prev => prev + 1); // force refresh

//   // ✅ Difficulty count update
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1);
//       } else {
//         updated[difficulty] += 1;
//       }
//       return updated;
//     });
//   }
// };

// const fetchDashboardData = async () => {
//   if (
//     (!selectedTags || selectedTags.length === 0) &&
//     (!filters || filters.length === 0)
//   ) {
//     setReportDashboardData([]);
//     // setAllQuestions?.([]);
//     return;
//   }

//   try {
//     const response = await fetch(
//       `${FULL_API_BASE_URL}/get-questions-by-tag-filters/?user_id=${userId}&subject_id=${subjectId}&course_id=${courseId}`,
//       {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           tags: selectedTags,
//           filters: filters,
//           scope_ref_id: scopeRefIds,
//         }),
//       }
//     );

//     const result = await response.json();
//     const rawTableData = result?.data?.table_data || [];
//     const rawHeaders = rawTableData[0] || [];
//     const rawRows = rawTableData.slice(1) || [];

//     const formattedHeaders = rawHeaders.map((header) => header.replace(/^t\*|d\*|n\*/, "") );

//     setHeaders(formattedHeaders);
//     setReportDashboardData(rawRows);
//     setSelectedHeaders(formattedHeaders);

//     // ✅ Now set all question IDs here
//     // if (setAllQuestions) {
//     //   const allQuestionIds = rawRows.map((row) => row[0]); // assuming question ID is in the first column
//     //   setAllQuestions(allQuestionIds);
//     //   //  const flagged = await fetchFlaggedQuestions(allQuestionIds);
//     //   //   setFlaggedQuestions(flagged);
//     //         }
//   } catch (error) {
//     console.error("Error fetching dashboard data:", error);
//   }
// };

// const fetchDashboardData = async () => {
//   const accessToken = localStorage.getItem("other");

//   const selectedMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   const selectedIds = selectedMap[activeSubjectId] || [];

//   const promises = [];

//   // 1. Get filtered data (if tags/filters are applied)
//   if ((selectedTags && selectedTags.length > 0) || (filters && Object.keys(filters).length > 0)) {
//     promises.push(
//       fetch(`${FULL_API_BASE_URL}/get-questions-by-tag-filters/?user_id=${userId}&subject_id=${subjectId}&course_id=${courseId}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ tags: selectedTags, filters: filters, scope_ref_id: scopeRefIds }),
//       }).then(res => res.json())
//     );
//   }

//   // 2. Get selected questions by IDs (ensure they're always shown)
//   if (selectedIds.length > 0) {
//     promises.push(
//       fetch(`${FULL_API_BASE_URL}/get-questions-by-ids`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(selectedIds),
//       }).then(res => res.json())
//     );
//   }

//   try {
//     const results = await Promise.all(promises);
//     const allData = [];

//     results.forEach((result) => {
//       const rawTableData = result?.data?.table_data || [];
//       const rawHeaders = rawTableData[0] || [];
//       const rawRows = rawTableData.slice(1);
//       allData.push(...rawRows);

//       if (headers.length === 0 && rawHeaders.length > 0) {
//         const cleanedHeaders = rawHeaders.map(h => h.replace(/^t\*|d\*|n\*/, ""));
//         setHeaders(cleanedHeaders);
//         setSelectedHeaders(cleanedHeaders);
//       }
//     });

//     // Remove duplicates by question ID (assumed at index 0)
//     const uniqueMap = {};
//     allData.forEach(row => {
//       uniqueMap[row[0]] = row; // Question ID is at index 0
//     });

//     const finalRows = Object.values(uniqueMap);

//     setReportDashboardData(finalRows);
//   } catch (error) {
//     console.error("Error fetching dashboard data:", error);
//   }
// };

// useEffect(() => {
//   if (!reportDashboardData || reportDashboardData.length === 0) return;

//   // ✅ Pull question IDs from the draft where status === 2
//   const selectedQuestionIdsFromDraft = draftData?.subjects?.flatMap((subject) =>
//     subject.questions?.filter((q) => q.status === 1).map((q) => q.parse_ques_set_question_id)
//   ) || [];

//   // ✅ Auto-select those questions
//   const selectedRowsFromDraft = reportDashboardData
//     .filter((row) => selectedQuestionIdsFromDraft.includes(row[0])) // assuming question ID is at index 0
//     .map((row) => row[0]);

//   const selectedQuestionObjects = reportDashboardData
//     .filter((row) => selectedQuestionIdsFromDraft.includes(row[0]));

//   setSelectedRows(selectedRowsFromDraft);
//   setSelectedQuestions(selectedQuestionObjects);

//   // ✅ Also optionally set difficulty count here if needed
//   const difficultyIndex = headers.findIndex((h) =>
//     h.toLowerCase().includes("difficulty")
//   );
//   const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//   selectedQuestionObjects.forEach((row) => {
//     const diff = row[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       difficultyCount[diff]++;
//     }
//   });

//   setDifficultyCount(difficultyCount);
// }, [reportDashboardData, draftData]); // <-- include draftData as dependency

//   useEffect(() => {
//   if (!reportDashboardData || reportDashboardData.length === 0) return;

//   const savedIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");
//   if (savedIds.length === 0) return;

//   const selectedFromStorage = reportDashboardData.filter((row) =>
//     savedIds.includes(row[0])
//   );

//   setSelectedRows(savedIds);
//   setSelectedQuestions(selectedFromStorage);

//   // Optional: Recalculate difficulty count
//   const difficultyIndex = headers.findIndex((h) =>
//     h.toLowerCase().includes("difficulty")
//   );
//   const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//   selectedFromStorage.forEach((row) => {
//     const diff = row[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(diff)) {
//       difficultyCount[diff]++;
//     }
//   });

//   setDifficultyCount(difficultyCount);
// }, [reportDashboardData]);

//   useEffect(() => {
//   const selectedIds = selectedQuestions.map((row) => row[0]);
//   setSelectedRows((prev) => prev.filter((id) => selectedIds.includes(id)));

//   // ✅ Update difficulty count
//   const difficultyIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );

//   const difficultyCount = { easy: 0, medium: 0, tough: 0 };

//   selectedQuestions.forEach((row) => {
//     const difficulty = row[difficultyIndex]?.toLowerCase();
//     if (["easy", "medium", "tough"].includes(difficulty)) {
//       difficultyCount[difficulty]++;
//     }
//   });

//   setDifficultyCount(difficultyCount);
// }, [selectedQuestions]);

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Update selectedRows
//   const updatedRows = isAlreadySelected
//     ? selectedRows.filter((id) => id !== questionId)
//     : [...selectedRows, questionId];
//   setSelectedRows(updatedRows);

//   // ✅ Update selectedQuestions
//   setSelectedQuestions((prev) =>
//     isAlreadySelected
//       ? prev.filter((row) => row[0] !== questionId)
//       : [...prev, selectedRow]
//   );
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1); // remove
//       } else {
//         updated[difficulty] += 1; // add
//       }
//       return updated;
//     });
//   }
// };

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();
//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Update selectedRows state
//   const updatedRows = isAlreadySelected
//     ? selectedRows.filter((id) => id !== questionId)
//     : [...selectedRows, questionId];
//   setSelectedRows(updatedRows);

//   // ✅ Update localStorage and selectedQuestions state
//   const stored = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
//   let updatedList;
//   if (isAlreadySelected) {
//     updatedList = stored.filter((row) => row[0] !== questionId);
//   } else {
//     const alreadyInStorage = stored.some((row) => row[0] === questionId);
//     updatedList = alreadyInStorage ? stored : [...stored, selectedRow];
//   }

//   localStorage.setItem("selectedQuestions", JSON.stringify(updatedList));
//   setSelectedQuestions(updatedList); // 🔁 Sync to selected questions table

//   // ✅ Update difficulty count
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1);
//       } else {
//         updated[difficulty] += 1;
//       }
//       return updated;
//     });
//   }
// };

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();
//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Update selectedRows state
//   const updatedRows = isAlreadySelected
//     ? selectedRows.filter((id) => id !== questionId)
//     : [...selectedRows, questionId];
//   setSelectedRows(updatedRows);

//   // ✅ Update localStorage and selectedQuestions state
//   const stored = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
//   let updatedList;
//   if (isAlreadySelected) {
//     updatedList = stored.filter((row) => row[0] !== questionId);
//   } else {
//     const alreadyInStorage = stored.some((row) => row[0] === questionId);
//     updatedList = alreadyInStorage ? stored : [...stored, selectedRow];
//   }

//   // localStorage.setItem("selectedQuestions", JSON.stringify(updatedList));
//   // setSelectedQuestions(updatedList); // 🔁 Sync to selected questions table

//   localStorage.setItem("selectedQuestions", JSON.stringify(updatedList));
// localStorage.setItem("selectedHeaders", JSON.stringify(headers)); // ✅ Save headers too
// setSelectedQuestions(updatedList); // 🔁 Sync to selected questions table

//   // ✅ Update difficulty count
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1);
//       } else {
//         updated[difficulty] += 1;
//       }
//       return updated;
//     });
//   }
// };

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Update selectedRows
//   const updatedRows = isAlreadySelected
//     ? selectedRows.filter((id) => id !== questionId)
//     : [...selectedRows, questionId];

//   setSelectedRows(updatedRows);

//   // ✅ Save selected question IDs in localStorage
//   localStorage.setItem("selectedRowIds", JSON.stringify(updatedRows));

//   // ✅ Update selectedQuestions
//   setSelectedQuestions((prev) =>
//     isAlreadySelected
//       ? prev.filter((row) => row[0] !== questionId)
//       : [...prev, selectedRow]
//   );

//   // ✅ Update difficulty count
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1); // remove
//       } else {
//         updated[difficulty] += 1; // add
//       }
//       return updated;
//     });
//   }
// };

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Fetch from localStorage and merge/remove properly
//   const existingIds = JSON.parse(localStorage.getItem("selectedRowIds") || "[]");

//   let updatedStorageIds;
//   if (isAlreadySelected) {
//     updatedStorageIds = existingIds.filter((id) => id !== questionId);
//   } else {
//     updatedStorageIds = Array.from(new Set([...existingIds, questionId]));
//   }

//   localStorage.setItem("selectedRowIds", JSON.stringify(updatedStorageIds));
//   setSelectedRows(updatedStorageIds);

//   // ✅ Add or remove question data from selectedQuestions
//   setSelectedQuestions((prev) =>
//     isAlreadySelected
//       ? prev.filter((row) => row[0] !== questionId)
//       : [...prev, selectedRow]
//   );

//   // ✅ Update difficulty count
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1); // remove
//       } else {
//         updated[difficulty] += 1; // add
//       }
//       return updated;
//     });
//   }
// };

// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const isAlreadySelected = selectedRows.includes(questionId);

//   // ✅ Load subject-wise selection map from localStorage
//   const storedMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");

//   const currentSubjectId = String(activeSubjectId); // Ensure it's a string key
//   const currentSubjectList = storedMap[currentSubjectId] || [];

//   let updatedSubjectList;
//   if (isAlreadySelected) {
//     updatedSubjectList = currentSubjectList.filter((id) => id !== questionId);
//   } else {
//     updatedSubjectList = Array.from(new Set([...currentSubjectList, questionId]));
//   }

//   // ✅ Update and save the map
//   const updatedMap = {
//     ...storedMap,
//     [currentSubjectId]: updatedSubjectList,
//   };
//   localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updatedMap));

//   // ✅ Update selectedRows state for UI
//   setSelectedRows(updatedSubjectList);

//   // ✅ Update selectedQuestions list
//   setSelectedQuestions((prev) =>
//     isAlreadySelected
//       ? prev.filter((row) => row[0] !== questionId)
//       : [...prev, selectedRow]
//   );

//   // ✅ Update difficulty count
//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) {
//         updated[difficulty] = Math.max(0, updated[difficulty] - 1);
//       } else {
//         updated[difficulty] += 1;
//       }
//       return updated;
//     });
//   }
// };
// const handleRowSelect = (questionId) => {
//   const selectedRow = data.find((row) => row[0] === questionId);
//   const difficultyLevelIndex = headers.findIndex((header) =>
//     header.toLowerCase().includes("difficulty level")
//   );
//   const difficulty = selectedRow[difficultyLevelIndex]?.toLowerCase();

//   const isAlreadySelected = selectedRows.includes(questionId);

//   const existing = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
//   const subjectData = existing[activeSubjectId] || [];

//   let updatedSubjectData;
//   if (isAlreadySelected) {
//     updatedSubjectData = subjectData.filter((id) => id !== questionId);
//   } else {
//     updatedSubjectData = Array.from(new Set([...subjectData, questionId]));
//   }

//   const updated = {
//     ...existing,
//     [activeSubjectId]: updatedSubjectData,
//   };

//   localStorage.setItem("subjectWiseSelectedRowIds", JSON.stringify(updated));
//   setSelectedRows(updatedSubjectData);

//   setSelectedQuestions((prev) =>
//     isAlreadySelected ? prev.filter((row) => row[0] !== questionId) : [...prev, selectedRow]
//   );

//   if (["easy", "medium", "tough"].includes(difficulty)) {
//     setDifficultyCount((prev) => {
//       const updated = { ...prev };
//       if (isAlreadySelected) updated[difficulty] = Math.max(0, updated[difficulty] - 1);
//       else updated[difficulty] += 1;
//       return updated;
//     });
//   }
// };

//     let stored = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");
// if (isAlreadySelected) {
//   stored = stored.filter((row) => row[0] !== questionId);
// } else {
//   stored.push(selectedRow);
// }
// localStorage.setItem("selectedQuestions", JSON.stringify(stored));

// let stored = JSON.parse(localStorage.getItem("selectedQuestions") || "[]");

// // Remove if already selected, otherwise add uniquely
// if (isAlreadySelected) {
//   stored = stored.filter((row) => row[0] !== questionId);
// } else {
//   const isAlreadyInStorage = stored.some((row) => row[0] === questionId);
//   if (!isAlreadyInStorage) {
//     stored.push(selectedRow);
//   }
// }
// localStorage.setItem("selectedQuestions", JSON.stringify(stored));
// localStorage.setItem("selectedHeaders", JSON.stringify(headers));

// localStorage.setItem("selectedQuestions", JSON.stringify(stored));

// ✅ Update difficultyCount

//   const fetchFlaggedQuestions = async (questionIds) => {
//   const flagged = [];

//   await Promise.all(
//     questionIds.map(async (id) => {
//       try {
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-parse-ques-review-requests/?parse_ques_set_question_id=${id}`
//         );
//         const json = await res.json();
//         const isFlagged = json?.some((item) => item.status === 1);
//         if (isFlagged) flagged.push(id);
//       } catch (error) {
//         console.error(`Error fetching flag for question ${id}:`, error);
//       }
//     })
//   );

//   return flagged;
// };

{
  /* <input
                  type="checkbox"
                  className="delete-question-checkbox-dqc"
                  checked={(
                    JSON.parse(
                      localStorage.getItem("subjectWiseSelectedRowIds") || "{}"
                    )[activeSubjectId] || []
                  ).includes(selectedQuestionData.id)}
                  onChange={() => handleRowSelect(selectedQuestionData.id)}
                  disabled={isReadOnly}
                  style={{ opacity: isReadOnly ? 0.6 : 1 }}
                /> */
}

{
  /* {isQuesModalVisible && selectedQuestionData && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
        >
          <div
            className="modal-content-all-question"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-button"
              onClick={() => setIsQuesModalVisible(false)}
            >
              X
            </button>

            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  backgroundColor: "#D6D6D6",
                  padding: "8px",
                }}
              >
                QUESTION ID # {selectedQuestionData.id}
              </p>
            </div>

            <div
              className="modal-question-options"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
                boxSizing: "border-box",
              }}
            >
              <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                Question:
              </span>
              <div style={{ fontSize: "20px", marginTop: "10px" }}>
                {renderQuestionText(selectedQuestionData.text)}
              </div>
              {questionOptions.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Options:
                  </span>
                  <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                    {questionOptions.map((opt, i) => (
                      // <li key={opt.option_id} style={{ fontSize: "17px" }}>
                      //   {renderQuestionText(opt.option_text)}
                      // </li>
                      <li key={i} className="option-list-item">
                        <div className="toggle-radio">
                          <input
                            type="radio"
                            checked={opt.option_correct_flag}
                            readOnly
                          />
                          <div>{renderQuestionText(opt.option_text)}</div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      )} */
}
{
  /* Add Question Selection Checkbox in Modal View */
}
{
  /* {isQuesModalVisible && selectedQuestionData && (
        <div
          className="modal-overlay"
          onClick={() => setIsQuesModalVisible(false)}
        >
          <div
            className="modal-content-all-question"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="modal-close-button"
              onClick={() => setIsQuesModalVisible(false)}
            >
              X
            </button>

            <div className="modal-header-del">
              <p
                style={{
                  fontSize: "18px",
                  backgroundColor: "#D6D6D6",
                  padding: "8px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                QUESTION ID - {selectedQuestionData.id}
              </p>
            </div>

            <div
              className="modal-question-options"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
                boxSizing: "border-box",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Question:
                </span>
              </div>
              
              <div style={{ fontSize: "20px", marginTop: "10px" }}>
                {renderQuestionText(selectedQuestionData.text)}
              </div>
              
              {questionOptions.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                    Options:
                  </span>
                  <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                    {questionOptions.map((opt, i) => (
                      <li key={i} className="option-list-item">
                        <div className="toggle-radio">
                          <input
                            type="radio"
                            checked={opt.option_correct_flag}
                            readOnly
                          />
                          <div>{renderQuestionText(opt.option_text)}</div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="footer-spacer" />
                  <div className="modal-actions">
                    <div className="modal-actions-left" />
                    <div className="modal-actions-right">
                      <button
                        type="button"
                        onClick={handlePrevQuestion}
                        disabled={currentModalIndex <= 0}
                        className="btn-secondary action-btn"
                      >
                        Previous
                      </button>
                      {(() => {
                        const selectedMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
                        const selectedIds = selectedMap[activeSubjectId] || [];
                        const isSelected = selectedIds.includes(selectedQuestionData.id);
                        return (
                          <button
                            type="button"
                            onClick={() => handleRowSelect(selectedQuestionData.id)}
                            disabled={isReadOnly}
                            className={`btn-primary-soft action-btn ${isSelected ? "is-selected" : ""}`}
                            title={isSelected ? "Unselect this question" : "Select this question"}
                          >
                            {isSelected ? "Remove" : "Add"}
                          </button>
                        );
                      })()}
                      <button
                        type="button"
                        onClick={handleNextQuestion}
                        disabled={currentModalIndex < 0 || currentModalIndex >= modalList.length - 1}
                        className="btn-secondary action-btn"
                      >
                        Next
                      </button>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      )} */
}

{
  /* {isQuesModalVisible && selectedQuestionData && (
          <div className="modal-overlay" onClick={() => setIsQuesModalVisible(false)}>
            <button
              className="modal-close-outside"
              aria-label="Close"
              onClick={(e) => { e.stopPropagation(); setIsQuesModalVisible(false); }}
            >
              ×
            </button>

            <div className="modal-content-all-question" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header-del">
                <p 
                // className="modal-title no-bg-with-bottom-border"
                style={{
                    fontSize: "18px",
                    color: "#424342",
                    margin: 0,
                    padding: "10px 14px",
                    backgroundColor: "transparent",
                    borderBottom: "1px solid #d6d6d6",
                    userSelect: "none"
                  }}>
                  QUESTION ID - {selectedQuestionData.id}
                </p>
              </div>

              <div className="modal-question-options">
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                  <span style={{ fontSize: "18px",  color: "#424342" }}>Question:</span>
                </div>

                <div className="question-body-plain" style={{ fontSize: "18px"}}>
                  {renderQuestionText(selectedQuestionData.text)}
                </div>

                {questionOptions.length > 0 && (
                  <div style={{ marginTop: "20px" }}>
                    <span style={{  color: "#424342", fontSize: "18px" }}>Options:</span>
                    <ul style={{ marginTop: "10px", paddingLeft: "20px" }}>
                      {questionOptions.map((opt, i) => (
                        <li key={i} className="option-list-item">
                          <div className="toggle-radio">
                            <input type="radio" checked={opt.option_correct_flag} readOnly />
                            <div>{renderQuestionText(opt.option_text)}</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="footer-spacer" />
                <div className="modal-actions">
                  <div className="modal-actions-left" />
                  <div className="modal-actions-right">
                    <button type="button" onClick={handlePrevQuestion} disabled={currentModalIndex <= 0} className="btn-secondary action-btn">Previous</button>
                    {(() => {
                      const selectedMap = JSON.parse(localStorage.getItem("subjectWiseSelectedRowIds") || "{}");
                      const selectedIds = selectedMap[activeSubjectId] || [];
                      const isSelected = selectedIds.includes(selectedQuestionData.id);
                      return (
                        <button
                          type="button"
                          onClick={() => handleRowSelect(selectedQuestionData.id)}
                          disabled={isReadOnly}
                          className={`btn-primary-soft action-btn ${isSelected ? "is-selected" : ""}`}
                          title={isSelected ? "Unselect this question" : "Select this question"}
                        >
                          {isSelected ? "Remove" : "Add"}
                        </button>
                      );
                    })()}
                    <button type="button" onClick={handleNextQuestion} disabled={currentModalIndex < 0 || currentModalIndex >= modalList.length - 1} className="btn-secondary action-btn">Next</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */
}
